import { combineReducers } from "redux"
import inventories from "./inventories"

const inventoryReducer = combineReducers({
  inventories,
})

export default inventoryReducer
